import { useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceReviewOverviewTeamInsightsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { EmptyState } from 'modules/performance_process/components/insights/Answers/common/EmptyState'
import { TeamInsights } from 'modules/performance_process/components/insights/TeamInsights'
import {
  Filters,
  useFilterManager,
} from 'modules/performance_process/components/review/show/Filters'
import {
  isManagerFilterVisible,
  useFiltersValues,
} from 'modules/performance_process/components/review/show/Filters/context'
import { FiltersWrapper } from 'modules/performance_process/components/review/show/FiltersWrapper'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

const ReviewOverviewTeamInsightsPage = () => {
  const { reviewProcess, canOnlySeePersonalResults } =
    useOutletContext<ReviewOverviewOutletContext>()
  const { access } = useCurrentSession()
  const filters = useFiltersValues()

  const { data, loading } = useQuery(PerformanceReviewOverviewTeamInsightsPageDocument, {
    variables: {
      managerId: String(filters.managerId),
    },
    skip: !filters.managerId,
  })

  const managerAccessId = data?.employees.employeeName?.access?.id

  const { persistentFilters, conditionalFilters, availableFilters, onSelectFilter } =
    useFilterManager({
      configType: 'teamInsights',
    })

  if (canOnlySeePersonalResults) return null

  return (
    <>
      <FiltersWrapper>
        <Filters.FilterManager
          persistentFilters={persistentFilters}
          conditionalFilters={conditionalFilters}
          availableFilters={availableFilters}
          onSelectFilter={onSelectFilter}
        />
      </FiltersWrapper>

      <Box paddingTop="s32" gap="s16">
        {loading ? (
          <Box flexGrow justifyContent="center" alignItems="center">
            <Spinner />
          </Box>
        ) : isManagerFilterVisible(reviewProcess) && !managerAccessId ? (
          <Box flexGrow justifyContent="center" alignItems="center">
            <EmptyState
              title={i18n.t('performance_process.insights.answers.empty_state_all_answers')}
            />
          </Box>
        ) : (
          <TeamInsights
            reviewId={reviewProcess.id}
            forAccessId={managerAccessId || access.id}
            noBorder
          />
        )}
      </Box>
    </>
  )
}

export default ReviewOverviewTeamInsightsPage
